import { useEffect, useState } from 'react';
import sessionStorageService from '../services/sessionStorage';
import ticketsService from '../services/tickets';
import { tickets, pagediscountTickets } from '../lib/tickets';
import { googleAnalytics4AddItemToBasket } from '../services/tracking';
import { calculateDiscountPrice } from '../utils';
import TicketsService from '../services/tickets';
import tracking from '../helpers/tracking';

const useTickets = (prizeId) => {
  const [activeTicket, setTicket] = useState(null);
  const [loading, setLoading] = useState(false);
  let [result, setResult] = useState(null);
  let [ticketsBundles, setBundles] = useState([]);
  let [settings, setSettings] = useState(null);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const type = String(process.env.REACT_APP_TYPE);

  const addToBasket = (ticket) => async () => {
    setLoading(true);
    setTicket(ticket.numOfTickets);
    let order = {
      numOfTickets: ticket.numOfTickets,
      prizeId: prizeId,
      prizeType: ticket.prizeType,
      bonusDraw: ticket.bonusDraw,
    };
    const createdOrder = await ticketsService.createUnAuthOrder(order);
    tracking.twitterAddToCartTrack(createdOrder.data.order.totalCost / 100);
    googleAnalytics4AddItemToBasket(
      createdOrder.data,
      calculateDiscountPrice(ticket),
      ticket.tickets * 2
    );
    order._id = createdOrder.data.orderId;

    const basketData = sessionStorageService.getBasketData();
    const subscriptionBasketData =
      sessionStorageService.getSubscriptionBasketData();
    let orderIds = [];
    let subscriptionIds =
      subscriptionBasketData && subscriptionBasketData.length > 0
        ? subscriptionBasketData.map((sub) => sub._id)
        : [];
    if (basketData != null) {
      if (basketData.length > 0) {
        basketData.push(order);
        sessionStorageService.setBasketData(basketData);
        // const generatedToken = await ticketsService.generateBasketToken(
        //   basketData
        // );
        // ticketsService.redirectByToken(generatedToken.data.fulfillmentValue);
        orderIds = basketData.map((element) => element._id);
      } else {
        sessionStorageService.setBasketData([order]);
        // const generatedToken = await ticketsService.generateBasketToken([
        //   order,
        // ]);
        // ticketsService.redirectByToken(generatedToken.data.fulfillmentValue);
        orderIds.push(order._id);
      }
    } else {
      sessionStorageService.setBasketData([order]);
      // const generatedToken = await ticketsService.generateBasketToken([order]);
      // ticketsService.redirectByToken(generatedToken.data.fulfillmentValue);
      orderIds.push(order._id);
    }

    if (orderIds.length > 0) {
      const orderIdsStr = orderIds.join(';');
      if (subscriptionIds.length > 0) {
        const subscriptionIdsStr = subscriptionIds.join(';');
        ticketsService.redirectByOrderWithSubscriptionIds(
          orderIdsStr,
          subscriptionIdsStr
        );
      } else {
        ticketsService.redirectByOrderIds(orderIdsStr);
      }
    }

    setLoading(false);
    setTicket(null);
  };

  const addSubscriptionToBasket = (sub) => async () => {
    setLoading(true);
    setActiveSubscription(sub);
    let subscription = {
      charity: "DEFAULT",
      totalCost: sub.totalCost,
      count: 0,
      numOfTickets: sub.numOfTickets,
      extra: sub.extra,
      subscriptionModel: sub._id,
      status: "PENDING_BASKET",
      raffle: prizeId,
      month: 1,
    };

    const createdSubscription = await ticketsService.createUnAuthSubscription(
      subscription
    );
    console.log("createdSubscription", createdSubscription);

    tracking.twitterAddToCartTrack(
      createdSubscription.data.subscription.totalCost / 100
    );
    googleAnalytics4AddItemToBasket(
      createdSubscription.data,
      calculateDiscountPrice(sub),
      sub.tickets * 2
    );
    subscription._id = createdSubscription.data.subscription._id;

    const subscriptionBasketData =
      sessionStorageService.getSubscriptionBasketData();
    let orderIds = [];
    let subscriptionIds =
      subscriptionBasketData && subscriptionBasketData.length > 0
        ? subscriptionBasketData.map((sub) => sub._id)
        : [];
    if (subscriptionBasketData != null) {
      if (subscriptionBasketData.length > 0) {
        subscriptionBasketData.push(subscription);
        sessionStorageService.setSubscriptionData(subscriptionBasketData);
        subscriptionIds = subscriptionBasketData.map((element) => element._id);
      } else {
        sessionStorageService.setSubscriptionData([subscription]);
        subscriptionIds.push(subscription._id);
      }
    } else {
      sessionStorageService.setSubscriptionData([subscription]);
      subscriptionIds.push(subscription._id);
    }

    if (subscriptionIds.length > 0) {
      const subscriptionIdsStr = subscriptionIds.join(";");
      let orderIdsStr = orderIds.join(";");
      ticketsService.redirectByOrderWithSubscriptionIds(
        orderIdsStr,
        subscriptionIdsStr
      );
    }

    setLoading(false);
    setActiveSubscription(null);
  };

  useEffect(() => {
    TicketsService.calculateLandingTicketSelector({
      prizeId: prizeId,
      type: 'raffle',
      ticketsCount: 0,
      coupon: null,
      landingType: 'OFFER',
    }).then((result) => {
      let bundles = result.data.generalSettings.ticketsBundles.reverse();
      setBundles(bundles);
      setSettings(result.data.generalSettings);
      setResult(result.data);
      setLoading(false);
    });
  }, []);

  const currentTickets =
    type === 'pagediscount' ? pagediscountTickets : tickets;
  return {
    type,
    activeTicket,
    activeSubscription,
    prizeId,
    loading,
    tickets: currentTickets,
    result,
    addToBasket,
    addSubscriptionToBasket,
    ticketsBundles,
    settings,
  };
};

export default useTickets;
